<script setup lang="ts">
import { trans } from '@tools/translation.ts';
import { directive as clickAway } from 'vue3-click-away';
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';
import Button from '@components/Button.vue';
import { IconArrowCounterClockwiseFillBlack } from '@icons';

defineOptions({ directives: { clickAway } });

const { isOpen } = defineProps<{ isOpen: boolean; }>();

const emit = defineEmits<{(e: 'update:isOpen', value: boolean): void; }>();

const handleClickOutside = (): void => {
  if (!isOpen) {
    return;
  }

  emit('update:isOpen', false);
};
</script>

<template>
  <div v-click-away="handleClickOutside" class="relative">
    <Button
      :class="[
        '!flex gap-2',
        { '!border-blue !bg-blue-lightest': isOpen }
      ]"
      @click="emit('update:isOpen', !isOpen)"
    >
      <slot name="icon" />

      <Typography variant="body-bold" :color="isOpen ? 'blue' : 'black'">
        <slot name="label" />
      </Typography>
    </Button>

    <div
      v-if="isOpen"
      :class="[
        'absolute left-0 top-full z-50 mt-3',
        'rounded border border-solid border-gray shadow-md',
        'bg-white'
      ]"
    >
      <slot name="panel" />

      <div
        :class="[
          'border-x-0 border-b-0 border-t border-solid border-gray',
          'flex justify-between p-3'
        ]"
      >
        <Button
          variant="invisible"
          :class="[
            '!w-fit',
            '!flex !items-center',
            '!px-1 !py-0.5',
          ]"
        >
          <Icon
            :svg="IconArrowCounterClockwiseFillBlack"
            width="24"
            height="24"
            class="mx-2"
          />

          <Typography variant="body-bold">
            {{ trans('search.filters.reset') }}
          </Typography>
        </Button>

        <Button
          class="!w-fit whitespace-nowrap"
          variant="primary"
        >
          {{ trans('modal.filters.button') }}
        </Button>
      </div>
    </div>
  </div>
</template>
